(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/conditionals.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/conditionals.js');

'use strict';

const productMapping = svs.numbergames.productMapping;
function ifIsProlongation(_ref) {
  let params = _ref.params,
    calls = _ref.calls;
  return () => {
    const _params = params(),
      wagerId = _params.wagerId;
    if (wagerId) {
      return {
        calls: calls()
      };
    }
  };
}
function ifHasIncompleteWagers(_ref2) {
  let params = _ref2.params,
    calls = _ref2.calls;
  return () => {
    const _params2 = params(),
      incompleteWagers = _params2.incompleteWagers;
    if (incompleteWagers !== null && incompleteWagers !== void 0 && incompleteWagers.length) {
      return {
        calls: calls()
      };
    }
  };
}
function ifDrawHasClosed(_ref3) {
  let params = _ref3.params,
    calls = _ref3.calls;
  return () => {
    const _params3 = params(),
      closedWager = _params3.closedWager;
    if (closedWager) {
      return {
        calls: calls()
      };
    }
  };
}
function ifDrawOpenIsToday(_ref4) {
  let params = _ref4.params,
    calls = _ref4.calls;
  return () => {
    const _params4 = params(),
      wagers = _params4.wagers,
      draws = _params4.draws,
      lastDrawDate = _params4.lastDrawDate;
    const productOpenedToday = wagers.map(_ref5 => {
      let bets = _ref5.bets;
      return bets[0].productId;
    }).find(productId => dateFns.isToday(new Date(draws[productId].regOpenTime)));
    const skipDialog = lastDrawDate && dateFns.isToday(new Date(lastDrawDate));
    if (productOpenedToday && !skipDialog) {
      return {
        calls: calls({
          productOpenedToday,
          regCloseTime: draws[productOpenedToday].regCloseTime
        })
      };
    }
  };
}
function ifHasClosedJokerDraws(_ref6) {
  let params = _ref6.params,
    calls = _ref6.calls;
  return () => {
    const _params5 = params(),
      wagers = _params5.wagers,
      draws = _params5.draws;
    const productWithClosedJoker = wagers
    .filter(_ref7 => {
      let bets = _ref7.bets;
      return bets.some(bet => productMapping.isJoker(bet.productId));
    })
    .map(_ref8 => {
      let bets = _ref8.bets;
      return bets[0].productId;
    })
    .find(productId => !draws[productId].jokerDraw);
    if (productWithClosedJoker) {
      return {
        calls: calls({
          productWithClosedJoker
        })
      };
    }
  };
}
Object.assign(svs.numbergames.pay_numbergames, {
  ifIsProlongation,
  ifHasIncompleteWagers,
  ifDrawHasClosed,
  ifDrawOpenIsToday,
  ifHasClosedJokerDraws
});

 })(window);